<!-- Breadcrumb -->
 <!-- routerLink="null" -->
  <ol class="flex items-center"
  >
  @if(pageTitle === 'Summary'){
   <li class="inline-flex items-center py-1 px-2.5 relative">
   <div class="flex gap-2">
     <button class="flex gap-2.5 items-center text-sm text-gray-800 font-semibold cursor-pointer"
             (click)="navigateToSummary('')"
             [ngClass]="childPath === 'summary' ? 'text-[#141414] underline' : ''">
       Summary
     </button>
  <span class="text-[#C4CADA]">|</span>
     
     <button class="flex gap-2.5 items-center text-sm text-gray-800 font-semibold cursor-pointer"
             (click)="navigateToResourceBoard()"
             [ngClass]="childPath === 'resources-board' ? 'text-[#141414] underline' : ''">
       Resource Board
     </button>
   </div>
   </li>
  }
  @else{

  <li class="inline-flex items-center py-1 px-2.5">
    <span class="flex items-center text-sm font-semibold text-black">
      {{pageTitle}}
    </span>
  </li>
}
<!--  <span class="text-[#C4CADA]">/</span>-->
<!--  <li class="inline-flex items-center py-1 px-2.5 relative">-->
<!--    <button class="flex gap-2.5 items-center text-sm text-gray-800 font-semibold cursor-pointer"-->
<!--            (click)="toggleDropdown('headerMenu', $event)">-->
<!--      Tickets-->
<!--      <img src="../../../../../assets/images/icons/arrows/arrow-down.svg" class="relative top-[1px] h-[7px] shrink-0" alt="">-->
<!--    </button>-->
<!--    <div-->
<!--      class="py-2.5 rounded-xl absolute left-0 top-8 border border-gray-100 w-screen max-w-[150px] bg-white ease-in-out duration-200 opacity-0 z-50 shadow-md"-->
<!--      [ngClass]="isDropdownVisible('headerMenu') ? 'opacity-100 translate-y-0 visible': 'opacity-0 translate-y-6 invisible'">-->
<!--      <ul class="text-sm text-[#252F4A] font-medium leading-[18px]">-->
<!--        <li>-->
<!--          <a [routerLink]="['/tickets']" href="javascript:void(0)" class="mx-2.5 p-2.5 flex gap-2.5 items-center rounded-md hover:bg-[#f9f9f9]">-->
<!--            <span>Tickets</span>-->
<!--          </a>-->
<!--        </li>-->
<!--        <li>-->
<!--          <a [routerLink]="['/tickets-setup/priority']" href="javascript:void(0)" class="mx-2.5 p-2.5 flex gap-2.5 items-center rounded-md hover:bg-[#f9f9f9]">-->
<!--            <span>Setup</span>-->
<!--          </a>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
<!--  </li>-->
</ol>
